import { render, staticRenderFns } from "./ArtworkIntakeSettings.vue?vue&type=template&id=0b15fc14&scoped=true&"
import script from "./ArtworkIntakeSettings.vue?vue&type=script&lang=js&"
export * from "./ArtworkIntakeSettings.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkIntakeSettings.vue?vue&type=style&index=0&id=0b15fc14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b15fc14",
  null
  
)

export default component.exports